<ng-container *transloco="let t">
  @if (isCiamEnabled()) {
    <div
      id="login-card"
      class="login-card--ciam flex flex-col w-full max-w-[480px] max-sm:max-w-full min-w-0"
      [class.login-card--ciam-mobile]="showMobileOptions()"
    >
      <div class="bg-white p-14 max-sm:px-6 max-sm:py-10 flex flex-col gap-8" id="login-card-inner">
        @if (biometricLoginInProgress()) {
          <div id="mobile-verifying-container" class="flex flex-col items-center py-8">
            <img
              id="mobile-verifying-logo"
              [src]="logoUrl()"
              [alt]="partnerDisplayName()"
              class="h-14 w-auto mb-8"
              [class.login-card__ciam-logo]="showMobileOptions()"
              [class.!h-auto]="showMobileOptions()"
            />
            <mat-spinner id="mobile-verifying-spinner" diameter="48" class="mb-6"></mat-spinner>
            <h2 id="mobile-verifying-title" class="text-xl font-dm font-semibold text-ld-primary mb-2">
              {{ t('callbackLoadingTitle') }}
            </h2>
            <p id="mobile-verifying-message" class="text-ld-neutral-500 font-sourcesans m-0">
              {{ t('callbackLoadingMessage') }}
            </p>
          </div>
        } @else {
          <div id="login-header" class="flex flex-col items-start gap-6">
            <img
              id="login-logo"
              [src]="logoUrl()"
              [alt]="partnerDisplayName()"
              class="h-14 w-auto"
              [class.login-card__ciam-logo]="showMobileOptions()"
              [class.!h-auto]="showMobileOptions()"
            />
            <h1 id="login-title" class="login-card__ciam-heading m-0">
              {{ t('commonLabelsSignIn') }}
            </h1>
          </div>

          @if (errorMessage()) {
            <div
              id="login-error-message"
              class="bg-ld-error-light border border-ld-error rounded-lg px-4 py-3 text-ld-error text-sm"
              role="alert"
            >
              {{ errorMessage() }}
            </div>
          }

          @if (showBiometricLogin()) {
            <div id="biometric-login-container" class="flex flex-col items-center gap-4">
              <button
                type="button"
                id="biometric-login-button"
                class="login-card__ciam-btn text-white border-0 cursor-pointer transition-all hover:brightness-90 active:scale-[0.98] disabled:opacity-70 focus-visible:outline-2 focus-visible:outline-offset-2 flex items-center justify-center gap-2 w-full"
                (click)="onBiometricLogin()"
                [disabled]="loading()"
              >
                @switch (biometricIcon()) {
                  @case ('face') {
                    <svg
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      class="shrink-0"
                    >
                      <g clip-path="url(#faceIdClip)">
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M0.666626 2.00008C0.666626 1.2637 1.26358 0.666748 1.99996 0.666748H3.99996C4.36815 0.666748 4.66663 0.965225 4.66663 1.33341C4.66663 1.7016 4.36815 2.00008 3.99996 2.00008H1.99996V4.00008C1.99996 4.36827 1.70148 4.66675 1.33329 4.66675C0.965103 4.66675 0.666626 4.36827 0.666626 4.00008V2.00008Z"
                          fill="currentColor"
                        />
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M15.3333 14.0001C15.3333 14.7365 14.7363 15.3334 14 15.3334H12C11.6318 15.3334 11.3333 15.0349 11.3333 14.6667C11.3333 14.2986 11.6318 14.0001 12 14.0001H14V12.0001C14 11.6319 14.2984 11.3334 14.6666 11.3334C15.0348 11.3334 15.3333 11.6319 15.3333 12.0001V14.0001Z"
                          fill="currentColor"
                        />
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M14 0.666748C14.7363 0.666748 15.3333 1.2637 15.3333 2.00008V4.00008C15.3333 4.36827 15.0348 4.66675 14.6666 4.66675C14.2984 4.66675 14 4.36827 14 4.00008V2.00008L12 2.00008C11.6318 2.00008 11.3333 1.7016 11.3333 1.33341C11.3333 0.965225 11.6318 0.666748 12 0.666748L14 0.666748Z"
                          fill="currentColor"
                        />
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M1.99996 15.3334C1.26358 15.3334 0.666626 14.7365 0.666626 14.0001L0.666626 12.0001C0.666626 11.6319 0.965103 11.3334 1.33329 11.3334C1.70148 11.3334 1.99996 11.6319 1.99996 12.0001L1.99996 14.0001H3.99996C4.36815 14.0001 4.66663 14.2986 4.66663 14.6667C4.66663 15.0349 4.36815 15.3334 3.99996 15.3334H1.99996Z"
                          fill="currentColor"
                        />
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M8.33329 5.33342C8.70148 5.33342 8.99996 5.63189 8.99996 6.00008V9.00008C8.99996 9.55237 8.55224 10.0001 7.99996 10.0001H7.33329C6.9651 10.0001 6.66663 9.7016 6.66663 9.33342C6.66663 8.96523 6.9651 8.66675 7.33329 8.66675H7.66663V6.00008C7.66663 5.63189 7.9651 5.33342 8.33329 5.33342Z"
                          fill="currentColor"
                        />
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M4.66663 5.33342C5.03482 5.33342 5.33329 5.63189 5.33329 6.00008V6.66675C5.33329 7.03494 5.03482 7.33342 4.66663 7.33342C4.29844 7.33342 3.99996 7.03494 3.99996 6.66675V6.00008C3.99996 5.63189 4.29844 5.33342 4.66663 5.33342Z"
                          fill="currentColor"
                        />
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M11.3333 5.33342C11.7015 5.33342 12 5.63189 12 6.00008V6.66675C12 7.03494 11.7015 7.33342 11.3333 7.33342C10.9651 7.33342 10.6666 7.03494 10.6666 6.66675V6.00008C10.6666 5.63189 10.9651 5.33342 11.3333 5.33342Z"
                          fill="currentColor"
                        />
                        <path
                          d="M5.73712 10.9296C5.42475 11.242 5.42154 11.7566 5.78973 12.0007C6.44017 12.4319 7.20795 12.6667 7.99996 12.6667C8.79196 12.6667 9.55975 12.4319 10.2102 12.0007C10.5784 11.7566 10.5752 11.242 10.2628 10.9296C10.0546 10.7213 9.71907 10.7268 9.47361 10.8895C9.03994 11.177 8.52802 11.3336 7.99996 11.3336C7.47189 11.3336 6.95998 11.177 6.52631 10.8895C6.28085 10.7268 5.94536 10.7213 5.73712 10.9296Z"
                          fill="currentColor"
                        />
                      </g>
                      <defs>
                        <clipPath id="faceIdClip">
                          <rect width="16" height="16" fill="white" />
                        </clipPath>
                      </defs>
                    </svg>
                  }
                  @default {
                    <svg
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      class="shrink-0"
                    >
                      <path
                        d="M9.47263 11.1516C9.57297 10.7975 9.94134 10.5917 10.2956 10.692C10.6497 10.7923 10.8554 11.1607 10.7552 11.5149C10.4914 12.4469 10.1418 13.3435 9.71547 14.1946C9.55048 14.5236 9.15005 14.6563 8.82094 14.4915C8.49177 14.3265 8.3585 13.9261 8.52342 13.5969C8.9126 12.8201 9.23199 12.002 9.47263 11.1516ZM7.33331 7.33325C7.33331 6.96506 7.63179 6.66658 7.99998 6.66658C8.36813 6.66663 8.66665 6.96509 8.66665 7.33325C8.66665 9.80723 7.95668 12.1175 6.72915 14.0689C6.53314 14.3805 6.1215 14.4744 5.80987 14.2786C5.49829 14.0826 5.40437 13.6709 5.60024 13.3593C6.698 11.6142 7.33331 9.54881 7.33331 7.33325ZM12.6666 7.33325C12.6666 4.75592 10.5773 2.66659 7.99998 2.66659C7.14896 2.66659 6.35297 2.89369 5.6673 3.29028C5.34868 3.4746 4.94092 3.36595 4.75649 3.04744C4.57217 2.72882 4.68081 2.32107 4.99933 2.13664C5.88253 1.62573 6.90822 1.33325 7.99998 1.33325C11.3137 1.33325 14 4.01954 14 7.33325C14 9.04424 13.7611 10.7006 13.3144 12.2701C13.2137 12.6241 12.8449 12.8297 12.4909 12.7291C12.1368 12.6283 11.9312 12.2596 12.0319 11.9055C12.4452 10.4534 12.6666 8.9197 12.6666 7.33325ZM1.99998 7.33325C1.99998 6.2415 2.29246 5.2158 2.80336 4.3326C2.98779 4.01409 3.39555 3.90545 3.71417 4.08976C4.03268 4.2742 4.14132 4.68195 3.95701 5.00057C3.56042 5.68625 3.33331 6.48223 3.33331 7.33325C3.33331 8.47939 3.06979 9.56583 2.59959 10.5338C2.43874 10.8649 2.04009 11.0031 1.70896 10.8424C1.37778 10.6815 1.23948 10.2823 1.40037 9.95109C1.78426 9.16078 1.99998 8.27316 1.99998 7.33325ZM9.99998 7.33325C9.99998 6.2287 9.10452 5.33329 7.99998 5.33325C6.89541 5.33325 5.99998 6.22868 5.99998 7.33325C5.99998 9.29024 5.43985 11.1103 4.47198 12.649C4.46265 12.6638 4.45353 12.679 4.44464 12.6939C4.25663 13.0105 3.84715 13.115 3.53058 12.927C3.21404 12.739 3.11015 12.3295 3.29816 12.0129C3.31279 11.9883 3.32774 11.9638 3.34308 11.9394C4.18114 10.6071 4.66665 9.03188 4.66665 7.33325C4.66665 5.4923 6.15903 3.99992 7.99998 3.99992C9.8409 3.99995 11.3333 5.49232 11.3333 7.33325C11.3333 8.04157 11.2848 8.73968 11.1914 9.42375C11.1414 9.78839 10.8054 10.0439 10.4407 9.99406C10.076 9.9442 9.8206 9.60754 9.87042 9.24276C9.95569 8.61835 9.99998 7.98089 9.99998 7.33325Z"
                        fill="currentColor"
                      />
                    </svg>
                  }
                }
                <span>{{ biometricLabel() }}</span>
              </button>
              <button
                type="button"
                id="biometric-use-email-button"
                class="login-card__ciam-btn bg-[#E6E5EA]! text-[#222222]! border-0 cursor-pointer transition-all hover:brightness-95 active:scale-[0.98] focus-visible:outline-2 focus-visible:outline-offset-2 flex items-center justify-center gap-2 w-full"
                (click)="onUseEmailInstead()"
              >
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  class="shrink-0"
                >
                  <path
                    d="M13.3333 6.57886L9.10929 9.39526C8.43755 9.84303 7.56229 9.84303 6.89054 9.39526L2.66659 6.57886V11.3334C2.66659 11.7016 2.96506 12.0001 3.33325 12.0001H12.6666C13.0348 12.0001 13.3333 11.7016 13.3333 11.3334V6.57886ZM13.3333 4.66675C13.3333 4.29856 13.0348 4.00008 12.6666 4.00008H3.33325C2.96506 4.00008 2.66659 4.29856 2.66659 4.66675V4.97664L7.63013 8.28589C7.854 8.43507 8.14583 8.43507 8.36971 8.28589L13.3333 4.97664V4.66675ZM14.6666 11.3334C14.6666 12.438 13.7712 13.3334 12.6666 13.3334H3.33325C2.22868 13.3334 1.33325 12.438 1.33325 11.3334V4.66675C1.33325 3.56218 2.22868 2.66675 3.33325 2.66675H12.6666C13.7712 2.66675 14.6666 3.56218 14.6666 4.66675V11.3334Z"
                    fill="currentColor"
                  />
                </svg>
                <span>{{ t('authLoginUseEmailInstead') }}</span>
              </button>
            </div>
          } @else {
            <form id="login-form" [formGroup]="loginForm" (ngSubmit)="onSubmit()" class="flex flex-col gap-6">
              <div class="flex flex-col">
                <mat-form-field
                  id="email-field"
                  appearance="fill"
                  subscriptSizing="dynamic"
                  class="w-full login-card__ciam-input"
                >
                  <input
                    matInput
                    #emailInput
                    id="email-input"
                    type="email"
                    formControlName="email"
                    aria-required="true"
                    [placeholder]="t('loginCardEnterEmailAddress')"
                    [attr.aria-invalid]="loginForm.get('email')?.invalid && loginForm.get('email')?.touched"
                    (keydown.enter)="onEnterKey($event)"
                  />
                  @if (
                    loginForm.get('email')?.hasError('required') && (formSubmitted() || loginForm.get('email')?.dirty)
                  ) {
                    <mat-error id="email-error-required">{{ t('commonValidationEmailRequired') }}</mat-error>
                  } @else if (
                    loginForm.get('email')?.hasError('nativeEmailError') &&
                    (formSubmitted() || loginForm.get('email')?.dirty)
                  ) {
                    <mat-error id="email-error-native">{{ t('commonValidationInvalidEmail') }}</mat-error>
                  }
                </mat-form-field>

                @if (isNativePlatform()) {
                  <div id="ciam-remember-email-container" class="flex justify-between items-center pt-2">
                    <label
                      for="ciam-remember-email-toggle"
                      class="font-dm text-sm font-normal leading-5 tracking-[0.28px] text-ld-neutral-500 cursor-pointer"
                    >
                      {{ t('authLoginRememberEmail') }}
                    </label>
                    <mat-slide-toggle
                      id="ciam-remember-email-toggle"
                      [checked]="rememberEmail()"
                      (change)="toggleRememberEmail()"
                      class="cursor-pointer"
                    />
                  </div>

                  @if (biometricAvailable() && isCiamEnabled()) {
                    <div id="ciam-biometric-container" class="flex justify-between items-center pt-1">
                      <label
                        for="ciam-biometric-toggle"
                        class="font-dm text-sm font-normal leading-5 tracking-[0.28px] text-ld-neutral-500 cursor-pointer"
                      >
                        {{ biometricLabel() }}
                      </label>
                      <mat-slide-toggle
                        id="ciam-biometric-toggle"
                        [checked]="useFaceId()"
                        (change)="toggleFaceId()"
                        class="cursor-pointer"
                      />
                    </div>
                  }
                }

                @if (!isJvTheme()) {
                  <p id="signup-text" class="login-card__ciam-signup-text m-0">
                    {{ t('authLoginHelocNewUser') }}
                    <button
                      type="button"
                      id="signup-link"
                      class="login-card__ciam-signup-link inline bg-transparent border-0 p-0 cursor-pointer hover:underline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:rounded"
                      (click)="onSignupClick()"
                    >
                      {{ t('authLoginHelocSignUpNow') }}
                    </button>
                  </p>
                }
              </div>

              <div class="flex justify-end">
                <button
                  type="submit"
                  id="login-button"
                  class="login-card__ciam-btn text-white border-0 cursor-pointer transition-all hover:brightness-90 active:scale-[0.98] disabled:opacity-70 disabled:cursor-wait focus-visible:outline-2 focus-visible:outline-offset-2 flex items-center justify-center gap-2"
                  [disabled]="loading()"
                  [attr.aria-busy]="loading()"
                >
                  @if (loading()) {
                    <mat-spinner
                      diameter="20"
                      id="login-spinner"
                      class="text-white! [&_circle]:stroke-white!"
                    ></mat-spinner>
                    <span>{{ t('authLoginSigningIn') }}</span>
                  } @else {
                    <span>{{ t('commonButtonsContinue') }}</span>
                  }
                </button>
              </div>
            </form>
          }
        }
      </div>

      @if (!isJvTheme()) {
        <div id="login-card-nmls" class="login-card__nmls flex items-center justify-center px-2.5 pt-6 pb-8">
          <span class="login-card__nmls-text">
            {{ nmlsCopyright() }}
          </span>
        </div>
      }
    </div>
  } @else {
    <div
      id="login-card"
      class="bg-white rounded-2xl shadow-card w-full max-w-[480px] min-w-0 p-6 sm:p-10"
      [class.!pt-5]="useBorderedInputs()"
      [class.!px-5]="useBorderedInputs()"
      [class.!pb-4]="useBorderedInputs()"
    >
      @if (!useBorderedInputs()) {
        <div id="login-header" class="flex flex-col items-center gap-2 mb-8">
          <img id="login-logo" [src]="logoUrl()" [alt]="partnerDisplayName()" class="h-14 w-auto" />
          <h1 id="login-title" class="text-section-heading text-ld-neutral-700 m-0">
            {{ t('commonLabelsSignIn') }}
          </h1>
        </div>
      }

      @if (errorMessage()) {
        <div
          id="login-error-message"
          class="bg-ld-error-light border border-ld-error rounded-lg px-4 py-3 mb-6 text-ld-error text-sm"
          role="alert"
        >
          {{ errorMessage() }}
        </div>
      }

      <form
        id="login-form"
        [formGroup]="loginForm"
        (ngSubmit)="onSubmit()"
        class="flex flex-col gap-6"
        [class.!gap-4]="useBorderedInputs()"
      >
        <mat-form-field
          id="email-field"
          appearance="outline"
          class="w-full"
          [class.mat-form-field-mobile]="useBorderedInputs()"
        >
          <mat-label>{{ t('commonFieldsEmail') }}</mat-label>
          <input
            matInput
            #emailInput
            id="email-input"
            type="email"
            formControlName="email"
            aria-required="true"
            [attr.aria-invalid]="
              loginForm.get('commonFieldsEmail')?.invalid && loginForm.get('commonFieldsEmail')?.touched
            "
            (keydown.enter)="onEnterKey($event)"
          />
          @if (loginForm.get('email')?.hasError('required')) {
            <mat-error id="email-error-required">{{ t('commonValidationEmailRequired') }}</mat-error>
          } @else if (loginForm.get('email')?.hasError('nativeEmailError')) {
            <mat-error id="email-error-native">{{ t('commonValidationInvalidEmail') }}</mat-error>
          }
        </mat-form-field>

        <mat-form-field
          id="password-field"
          appearance="outline"
          class="w-full"
          [class.mat-form-field-mobile]="useBorderedInputs()"
        >
          <mat-label>{{ t('commonFieldsPassword') }}</mat-label>
          <input
            matInput
            id="password-input"
            [type]="hidePassword() ? 'password' : 'text'"
            formControlName="password"
            aria-required="true"
            glance_masked="true"
            [attr.aria-invalid]="
              loginForm.get('commonFieldsPassword')?.invalid && loginForm.get('commonFieldsPassword')?.touched
            "
            (keydown.enter)="onEnterKey($event)"
          />
          <button
            type="button"
            matSuffix
            id="password-toggle-button"
            (click)="togglePasswordVisibility()"
            class="bg-transparent border-0 cursor-pointer p-0 pr-2 text-ld-neutral-500 flex items-center justify-center hover:text-ld-neutral"
            [attr.aria-label]="hidePassword() ? t('commonAriaShowPassword') : t('commonAriaHidePassword')"
          >
            <mat-icon>{{ hidePassword() ? 'visibility_off' : 'visibility' }}</mat-icon>
          </button>
          @if (loginForm.get('password')?.hasError('required')) {
            <mat-error id="password-error-required">{{ t('commonValidationPasswordRequired') }}</mat-error>
          } @else if (loginForm.get('password')?.hasError('minlength')) {
            <mat-error id="password-error-minlength">{{ t('commonValidationPasswordRequired') }}</mat-error>
          }
        </mat-form-field>

        <div id="remember-email-container" class="flex justify-between items-center">
          <mat-slide-toggle
            id="remember-email-toggle"
            [checked]="rememberEmail()"
            (change)="toggleRememberEmail()"
            class="remember-email-toggle"
          >
            <span class="font-dm text-sm font-normal leading-5 tracking-[0.28px] text-ld-neutral-500">
              {{ t('authLoginRememberEmail') }}
            </span>
          </mat-slide-toggle>
        </div>

        <button
          type="submit"
          id="login-button"
          class="w-full bg-ld-primary text-white border-0 font-dm text-base font-bold tracking-[0.1px] uppercase cursor-pointer transition-all hover:bg-ld-primary-hover active:scale-[0.98] disabled:bg-ld-primary disabled:cursor-wait focus-visible:outline-2 focus-visible:outline-ld-primary focus-visible:outline-offset-2 touch-target flex items-center justify-center gap-2"
          [class.h-11]="!useBorderedInputs()"
          [class.rounded-[22px]]="!useBorderedInputs()"
          [class.font-dm]="!useBorderedInputs()"
          [class.font-semibold]="!useBorderedInputs()"
          [class.py-2]="useBorderedInputs()"
          [class.px-5]="useBorderedInputs()"
          [class.rounded-[20px]]="useBorderedInputs()"
          [disabled]="loading()"
          [attr.aria-busy]="loading()"
        >
          @if (loading()) {
            <mat-spinner diameter="20" id="login-spinner" class="text-white! [&_circle]:stroke-white!"></mat-spinner>
            <span>{{ t('authLoginSigningIn') }}</span>
          } @else {
            <span>{{ t('commonLabelsSignIn') }}</span>
          }
        </button>

        <div id="helper-links" class="flex items-center justify-center gap-4 max-sm:gap-2">
          <button
            type="button"
            id="forgot-password-link"
            (click)="onForgotPasswordClick()"
            class="bg-transparent border-0 text-ld-link cursor-pointer p-0 font-dm text-sm font-medium leading-4 hover:underline focus-visible:outline-2 focus-visible:outline-ld-primary focus-visible:outline-offset-2 focus-visible:rounded touch-target"
          >
            {{ t('authLoginForgotPassword') }}
          </button>
        </div>

        <p id="sign-up-text" class="text-center font-dm text-sm leading-4 m-0">
          <span class="text-ld-neutral-700">{{ t('authLoginNoAccount') }}</span>
          <button
            type="button"
            id="sign-up-link"
            (click)="onRegisterClick()"
            class="bg-transparent border-0 text-ld-link cursor-pointer p-0 font-dm text-sm font-medium leading-4 hover:underline focus-visible:outline-2 focus-visible:outline-ld-primary focus-visible:outline-offset-2 focus-visible:rounded"
          >
            {{ t('authLoginSignUpNow') }}
          </button>
        </p>
      </form>
    </div>
  }
</ng-container>
